import { pixelate } from '../image-to-pixel';

const PIXEL_ART_RENDER_DEBUG = process.env.NODE_ENV !== 'production';

export const DEFAULT_PIXEL_ART_OPTIONS = {
    enabled: true,
    width: 320,
    dither: 'none',
    strength: 0,
    palette: null,
    resolution: 'original',
};

const getPixelWidth = (sourceCanvas, requestedWidth) =>
    Math.max(1, Math.min(sourceCanvas.width, requestedWidth));

const logPixelArtRender = (...args) => {
    if (PIXEL_ART_RENDER_DEBUG) {
        console.log('[pixel-art:renderer]', ...args);
    }
};

export const renderPixelArtCanvas = async (sourceCanvas, options = {}) => {
    const config = { ...DEFAULT_PIXEL_ART_OPTIONS, ...options };

    logPixelArtRender('render requested', {
        enabled: config.enabled,
        hasSourceCanvas: Boolean(sourceCanvas),
        sourceWidth: sourceCanvas?.width,
        sourceHeight: sourceCanvas?.height,
        config,
    });

    if (!config.enabled || !sourceCanvas) {
        logPixelArtRender('render skipped');
        return null;
    }

    const pixelWidth = getPixelWidth(sourceCanvas, config.width);

    logPixelArtRender('calling pixelate', {
        pixelWidth,
        dither: config.dither,
        hasPalette: Boolean(config.palette),
        resolution: config.resolution,
    });

    const pixelCanvas = await pixelate({
        image: sourceCanvas,
        width: pixelWidth,
        dither: config.dither,
        strength: config.strength,
        palette: config.palette,
        resolution: config.resolution,
    });

    logPixelArtRender('pixelate resolved', {
        width: pixelCanvas?.width,
        height: pixelCanvas?.height,
    });

    pixelCanvas.className = 'sketch-pixel-art-canvas';
    pixelCanvas.dataset.pixelArtOutput = 'true';
    pixelCanvas.setAttribute('aria-hidden', 'true');
    pixelCanvas.style.display = 'block';
    pixelCanvas.style.height =
        sourceCanvas.style.height || `${sourceCanvas.height}px`;
    pixelCanvas.style.imageRendering = 'pixelated';
    pixelCanvas.style.width =
        sourceCanvas.style.width || `${sourceCanvas.width}px`;

    return pixelCanvas;
};
